import { baseUrl, buildQueryParams } from "./Requests.js";

function getCompanyInfo(ticker, options = {}) {
  const params = buildQueryParams({
    ticker: ticker,
    page: 1,
    limit: 1
  });
  return (
    fetch(`${baseUrl}/companyinfo?${params.toString()}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      signal: options.signal,
    })
  );
}

async function requestCompanyInfo(paramsObj, options = {}) {
  const params = buildQueryParams(paramsObj);
  const response = await fetch(`${baseUrl}/company_autocomplete?${params.toString()}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    signal: options.signal,
  });

  if (!response.ok) {
    throw new Error("Company search request failed");
  }

  return response.json();
}

async function requestCompanyInfoItems(paramsObj, options = {}) {
  const data = await requestCompanyInfo(paramsObj, options);
  return Array.isArray(data?.data) ? data.data : [];
}

function getCompanySearchLabel(item) {
  const companyName = item?.companykor || item?.companyKor || item?.company || "";
  const ticker = item?.ticker || "";
  const nickname = item?.nickname || "";
  return `${companyName}${ticker}${nickname}`.trim();
}

async function searchCompanyInfo(keyword, size = 10, options = {}) {
  const trimmedKeyword = (keyword || "").trim();
  if (!trimmedKeyword) return [];

  const serverItems = await requestCompanyInfoItems({
    q: trimmedKeyword,
    page: 1,
    size: size,
  }, options);

  if (serverItems.length > 0) {
    const sortedItems = [...serverItems].sort((a, b) => {
      const lengthDiff = getCompanySearchLabel(a).length - getCompanySearchLabel(b).length;
      if (lengthDiff !== 0) return lengthDiff;

      const aTicker = (a?.ticker || "").toUpperCase();
      const bTicker = (b?.ticker || "").toUpperCase();
      return aTicker.localeCompare(bTicker);
    });
    return sortedItems.slice(0, size);
  }
  return [];
}

export { getCompanyInfo, searchCompanyInfo };
